import LoadingIndicator from './LoadingIndicator'

export default LoadingIndicator



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/index.js